import { addKeyAccessFormFields } from 'modules/AccessManage/components/AddUserKeyAccess/AddKeyAccessFormFields'
import UserInfoWrapper from 'modules/AccessManage/ui/UserInfoWrapper'

import FormItems from 'shared/ui/Form/FormItems'

const AddUserKeyAccess = () => {
  return (
    <UserInfoWrapper
      title="Ключ доступа"
      className="self-baseline"
    >
      <div className="flex flex-col gap-[12px]">
        <FormItems items={addKeyAccessFormFields} />
      </div>
    </UserInfoWrapper>
  )
}

export default AddUserKeyAccess
